module.exports = __webpack_public_path__ + "img/LogoKMgKweiss-1024x256.png";